module.exports = "span {\n  margin-left: 20px;\n}\n.spacer {\n  flex: 1 1 auto;\n}\n"